import { z, ZodError } from 'zod';
import {
	setStep,
	setFormState,
	resetErrors,
	clearError,
	setError,
	setClientSuccessValidation,
} from './store.js';

export function ucfirst(word) {
	if (!word) return '';
	return word.charAt(0).toUpperCase() + word.slice(1);
}

export function initSchema(fields) {
	if (!fields) return;
	return z.object(
		fields.reduce((schema, field) => {
			schema[field.gf_input_name] = field.validate;
			return schema;
		}, {})
	);
}

export function formatPhoneNumber(value, inputType) {
	// console.log('value = ', value);
	// console.log('inputType = ', inputType);

	if (inputType === 'deleteContentBackward') {
		// console.log('value.length = ', value.length);
		return value;
	}

	const cleaned = ('' + value).replace(/\D/g, '');
	// console.log('cleaned = ', cleaned);

	let formatted = '';
	if (cleaned.length > 0) {
		formatted += '(' + cleaned.slice(0, 3);
		if (cleaned.length >= 3) {
			formatted += ') ';
		}
		if (cleaned.length > 3) {
			formatted += cleaned.slice(3, 6);
		}
		if (cleaned.length >= 6) {
			formatted += '-' + cleaned.slice(6, 10);
		}
	}

	return formatted;
}

export function handleBlur(field) {
	const validation = field.validate.safeParse(field.value);
	// console.log('validation = ', validation);

	if (!validation.success) {
		// Set the first error message for this field
		// errors[field.gf_input_name] = {
		// 	_errors: [validation.error.errors[0].message],
		// };
		setError(field.gf_input_name, validation.error.errors[0].message);
	} else {
		// Clear errors if validation passed
		// delete errors[field.gf_input_name];
		clearError(field);
	}
}

export function validateStep(step, formFields, formSchema) {
	console.log('step = ', step);
	console.log('formFields = ', formFields);
	console.log('formSchema = ', formSchema);

	const formData = formFields.reduce((data, field) => {
		data[field.gf_input_name] = field.value;
		return data;
	}, {});

	const validation = formSchema.safeParse(formData);
	console.log('validation = ', validation);
	console.log('validation.error = ', validation.error);

	if (!validation.success) {
		resetErrors();
		validation.error.errors.forEach((err) => {
			// errors[err.path[0]] = { _errors: [err.message] };
			setError(err.path[0], err.message);
		});
		console.error('Validation Error:', validation.error);

		if (validation.error instanceof ZodError) {
			console.log('Validation Issues:', validation.error.issues);
			validation.error.issues.forEach((issue) => {
				console.log('issue.message = ', issue.message);
				// errors[issue.path[0]] = { _errors: [issue.message] };
				setError(issue.path[0], issue.message);
			});
		} else {
			console.error('Unexpected error structure:', validation.error);
		}
		return;
	}

	if (step === 1) setStep(2);
	else setClientSuccessValidation(validation);
}

// const consumerKey = process.env.GF_CONSUMER_KEY;
// const consumerSecret = process.env.GF_CONSUMER_SECRET;
export async function submitGravityForm(
	formId,
	formData,
	hiddenFields,
	activeProgramName,
	activeCampusName
) {
	setFormState('loading');
	const apiUrl = `https://westcoastuniversity.edu/wp-json/gf/v2/forms/${formId}/submissions`;
	// const apiUrl = `http://localhost:8080/wp-json/gf/v2/forms/${formId}/submissions`;
	const authString = `${process.env.GF_CONSUMER_KEY}:${process.env.GF_CONSUMER_SECRET}`;
	const encodedAuthString = btoa(authString);

	try {
		const response = await fetch(apiUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Basic ' + encodedAuthString,
			},
			body: JSON.stringify({
				...formData,
			}),
		});

		console.log('response = ', response);

		if (!response.ok) {
			console.log('response not ok');

			const errorResponse = await response.json();
			console.error('Error response:', errorResponse);
			console.log(`Form submission failed: ${errorResponse.message}`);
			return;
		}

		const result = await response.json();
		console.log('result = ', result);

		if (result.is_valid) {
			console.log('response = ', response);
			postToCatalyis(
				formData,
				formId,
				hiddenFields,
				activeProgramName,
				activeCampusName
			);
			// resetForm();
		} else {
			console.log('Form submission failed: ' + result.message);
			setFormState('error');
		}
	} catch (error) {
		console.error('Submission error:', error);
		// alert('There was an error submitting the form. Please try again later.');
		setFormState('error');
	}
}

export async function postToCatalyis(
	formData,
	formId,
	hiddenFields,
	activeProgramName,
	activeCampusName
) {
	try {
		console.log('postToCatalysis fired');
		console.log('formData = ', formData);

		const program = formData.input_12;
		const csdl = formData.input_43;

		console.log('program = ', program);
		console.log('csdl = ', csdl);

		let split = [];
		let programId, campusId;
		if (!csdl) {
			split = program.split(':');
			programId = split[0];
		} else {
			split = csdl.split(':');
			programId = split[0];
		}

		console.log('split = ', split);

		if (split[1] !== 'ONL') campusId = split[1];
		else campusId = '4';

		console.log('programId = ', programId);
		console.log('campusId = ', campusId);

		const catalysisRequestObject = {
			password: process.env.CATALYSIS_PASSWORD,
			Campus_Tour_Date_Time__c: '',
			Campus_Tour_Location__c: '',
			BusinessDevRepId_Alias__c: '',
			Campus_ID__c: campusId,
			Program_Version_ID__c: programId,
			First_Name__c: formData['input_1.3'],
			Last_Name__c: formData['input_1.6'],
			Email__c: formData.input_2,
			Mobile_Phone__c: formData.input_5,
			Mailing_Postal_Code__c: formData.input_27,
			Partner_Name__c: '',
			conversion_page: hiddenFields.conversion_page,
			IP_Address__c: hiddenFields.ip,
			Lead_Source_ID__c: hiddenFields.mkt_source,
			UserAgent: hiddenFields.user_agent,
		};

		console.log('catalysisRequestObject = ', catalysisRequestObject);

		console.log(
			'process.env.CATALYSIS_API_URL = ',
			process.env.CATALYSIS_API_URL
		);

		fetch(process.env.CATALYSIS_API_URL, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(catalysisRequestObject),
		})
			.then((response) => response.json()) // <- this reads and parses the body
			.then((data) => {
				console.log('catalysis response = ', data);
				setFormState('success');
				runDatalayerSubmitEvents(
					formId,
					hiddenFields,
					activeProgramName,
					activeCampusName,
					data.message
				);
				runTVSquaredSubmitEvent(data.message, activeProgramName);
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	} catch (error) {
		console.error('Server error: ', error);
		setFormState('error');
	}
}

export function checkPageIdMatch(programs, pageId) {
	if (!pageId) return null;

	for (const [modalityKey, categories] of Object.entries(programs)) {
		for (const entries of Object.values(categories)) {
			for (const entry of entries) {
				// Match at the top level
				if (entry.page_id === pageId) {
					return {
						modality: modalityKey,
						program_value: entry.value,
					};
				}
				// Match in children
				if (entry.children?.length) {
					for (const child of entry.children) {
						if (child.page_id === pageId) {
							return {
								modality: modalityKey,
								child_value: child.value,
								program_value: entry.value,
							};
						}
					}
				}
			}
		}
	}

	return null;
}

export function matchProgram(optGroups, targetValue) {
	for (const optGroup of Object.keys(optGroups)) {
		const programs = optGroups[optGroup];

		for (const program of programs) {
			if (program.value === targetValue) {
				return {
					program,
					optGroup,
				};
			}
		}
	}

	return null;
}

export const hiddenFields = {
	ip: '',
	user_agent: navigator.userAgent,
	conversion_page: window.location.href,
	mkt_source: 'INTINTWCUWEB',
};

export function setConversionPageAndIP(ip) {
	if (sessionStorage.entryPageQueryString) {
		hiddenFields.conversion_page += sessionStorage.entryPageQueryString;
	}

	hiddenFields.ip = ip;
}

export function setMktSource(event) {
	hiddenFields.mkt_source = event.detail.mktSource;
	console.log('setMktSource fired');
	console.log('event = ', event);
	console.log('hiddenFields = ', hiddenFields);
}

export const campuses = [
	{ id: 11, text: 'Los Angeles, California' },
	{ id: 15, text: 'Miami, Florida' },
	{ id: 9, text: 'Ontario, California' },
	{ id: 8, text: 'Orange County, California' },
	{ id: 12, text: 'Richardson, Texas' },
];

const forms = {
	3: {
		form_name: 'LEAD FORM: RFI - Exposed Inline - 2 Step',
		cta_position: 'Inline',
	},
	13: {
		form_name: 'LEAD FORM: RFI - Exposed Inline - 2 Step',
		cta_position: 'Inline',
	},
	7: {
		form_name: 'LEAD FORM: RFI - Modal - 2 Step',
		cta_position: 'Modal',
	},
	5: {
		form_name: 'BUSINESS DEVELOPMENT: Request for Information',
		cta_position: 'Inline',
	},
	8: {
		form_name: 'LEAD FORM: Info Session',
		cta_position: 'Inline',
	},
	9: {
		form_name: 'ALUMNI: Alumni Pathway Grant',
		cta_position: 'Inline',
	},
	16: {
		form_name: 'RFI- Refer a Friend',
		cta_position: 'Inline',
	},
	17: {
		form_name: 'LEAD FORM: RFI - Exposed Inline - Pre-Filled',
		cta_position: 'Inline',
	},
	29: {
		form_name: 'LEAD FORM: RFI - Exposed Inline - Pre-Filled',
		cta_position: 'Inline',
	},
	33: {
		form_name: 'LEAD FORM: RFI - Modal - Pre-Filled',
		cta_position: 'Modal',
	},
	34: {
		form_name: 'LEAD FORM: RFI - Exposed Inline - Pre-Filled',
		cta_position: 'Inline',
	},
	18: {
		form_name: 'LEAD FORM: RFI - Modal - Pre-Filled',
		cta_position: 'Modal',
	},
	23: {
		form_name: 'LEAD FORM: Info Session - Program First',
		cta_position: 'Inline',
	},
};

export function runDatalayerFormStartEvents(id) {
	const ga4FormStartObject = {
		event: 'lead_form_start',
	};

	const adobeAnalyticsFormStartObject = {
		event: 'form:start',
		component: {
			info: {
				formName: forms[id].form_name,
			},
		},
	};

	window.dataLayer.push(ga4FormStartObject);
	window.digitalData.push(adobeAnalyticsFormStartObject);
}

export function runDatalayerSubmitEvents(id, hidden, program, campus, webLeadId) {
	const ga4FormSubmitObject = {
		event: 'lead_form_submit',
		page_name: document.title,
		program_name: program,
		campus_name: campus,
		selected_medium: hidden.mkt_source,
		form_id: id,
		form_name: forms[id].form_name,
		lead_id: webLeadId,
		cta_position: forms[id].cta_position,
		landing_page_url: sessionStorage.landingPageUrl,
		full_query_string: sessionStorage.entryPageQueryString,
		full_page_url: window.location.href,
	};

	const adobeAnalyticsFormSubmitObject = {
		event: 'form:submit',
		component: {
			info: {
				formName: forms[id].form_namee,
				campusLocation: campus,
				programOfInterest: program,
				learningPreference: campus === 'Online' ? 'Online' : 'On-Campus',
				heardAboutUs: hidden.mkt_source,
			},
		},
	};

	window.dataLayer.push(ga4FormSubmitObject);
	window.digitalData.push(adobeAnalyticsFormSubmitObject);
}

function runTVSquaredSubmitEvent(webLeadId, programOfInterest) {
	/* eslint-disable */
	var _tvq = (window._tvq = window._tvq || []);
	(function () {
		var session = {
			user: webLeadId,
		};
		var actionname = 'Requestmoreinformation';
		var action = {
			rev: '',
			prod: programOfInterest,
			id: webLeadId,
			promo: '',
		};
		console.log('session = ', session);
		console.log('actionname = ', actionname);
		console.log('action = ', action);

		var u =
			'https:' == document.location.protocol
				? 'https://collector17169.us.tvsquared.com/'
				: 'http://collector-17169.us.tvsquared.com/';
		_tvq.push(['setSiteId', 'TV-54189036-1']);
		_tvq.push(['setTrackerUrl', u + 'tv2track.php']);
		_tvq.push([
			function () {
				this.setCustomVariable(5, 'session', JSON2.stringify(session), 'visit');
			},
		]);
		_tvq.push([
			function () {
				this.setCustomVariable(5, actionname, JSON2.stringify(action), 'page');
			},
		]);
		_tvq.push(['trackPageView']);
		var d = document,
			g = d.createElement('script'),
			s = d.getElementsByTagName('script')[0];
		g.type = 'text/javascript';
		g.defer = true;
		g.async = true;
		g.src = u + 'tv2track.js';
		s.parentNode.insertBefore(g, s);
	})();
	/* eslint-enable */
}
